import templateUrl from 'webutils/jsonld.htm'

const JsonLdComponent = { 
    bindings : {
        ngModel: '<'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    },
    controller($filter, $sce){
        this.$onInit = () => this.trustedJson = $sce.trustAsHtml($filter('json')(this.ngModel));
    }
};

export default JsonLdComponent;